import { GapContainer, Heading3, Icon, MATERIAL_ICONS, SpaceContainer, useTestId } from '@cmctechnology/webinvest-design-system';
import { SfOmniForm } from '../Modules';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

export interface SFPageProps {
  pageName?: string;
  hostUrl?: string;
}

export const SalesforceOmniFormPage: React.FC<SFPageProps> = ({ pageName, hostUrl, ...rest }) => {
  const { generateTestId } = useTestId(rest, `SalesforceOmniFormPage`);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <SpaceContainer gutter={16}>
      <GapContainer gutterBottom={16} gap={8} alignItems='center'>
        <Icon name={MATERIAL_ICONS.ArrowBack} {...generateTestId('Back')} onClick={() => navigate(-1)} />
        <Heading3 gutter={false} fontWeightCss='semiBold'>
          {t('Change confirmation')}
        </Heading3>
      </GapContainer>
      <SfOmniForm pageName={pageName} hostUrl={hostUrl} />
    </SpaceContainer>
  );
};
